import React from 'react';
import { Row } from 'react-bootstrap';

const FormRow = (props) => <Row {...props}>{props.children}</Row>;

const EmptyFormRow = () => <div style={{ minHeight: '45.6px' }}></div>;

export { FormRow, EmptyFormRow };
